import React, { Component } from "react";
import { Button, Col, Input, Modal, Row } from 'antd';
import { compose, graphql, withApollo } from 'react-apollo';
import { getUserByEmail } from "../queries/getUserByEmail";
import { deleteUserData } from "../mutations/deleteUserData";

const ROLE_LABELS = {
  ChurchMember: 'Church member',
  Pastor: 'Pastor',
  SeniorPastor: 'Senior pastor',
  Evangelist: 'Evangelist',
  Administrator: 'Administrator'
};

const ERASURE_WARNING = 'Every guest, prayer, fasting and overcoming record belonging to this ' +
  'profile will be deleted, and the profile itself anonymised. This action is irreversible.';

function errorMessage(response) {
  const error = response.graphQLErrors && response.graphQLErrors[0];
  const details = error && error.details;

  if (details) {
    const messages = Object.keys(details)
      .map((key) => Array.isArray(details[key]) && details[key][0] && details[key][0].message)
      .filter((message) => message);

    if (messages.length) {
      return messages[0];
    }
  }

  return response.toString();
}

class DataDeletion extends Component {
  constructor(props) {
    super(props);
    this.state = { email: '', user: null, searching: false, erasing: false };
  }

  onEmailChange = (event) => {
    this.setState({ email: event.target.value, user: null });
  };

  onSearch = async () => {
    const email = this.state.email.trim();

    if (!email) {
      return;
    }

    this.setState({ searching: true, user: null });

    try {
      const response = await this.props.client.query({
        query: getUserByEmail,
        variables: { email },
        fetchPolicy: 'network-only'
      });

      if (response.data.user) {
        this.setState({ user: response.data.user });
      } else {
        Modal.info({ content: 'No profile found for that email address.' });
      }
    } catch (response) {
      Modal.error({ content: errorMessage(response) });
    } finally {
      this.setState({ searching: false });
    }
  };

  onErase = () => {
    const { user } = this.state;

    Modal.confirm({
      title: `Erase all data for ${user.name}${user.church ? ` of ${user.church.name}` : ''}?`,
      content: ERASURE_WARNING,
      okText: 'Erase data',
      okType: 'danger',
      width: 560,
      onOk: () => this.erase(user.id)
    });
  };

  async erase(id) {
    this.setState({ erasing: true });

    try {
      await this.props.mutate({ variables: { input: { id } } });
      Modal.success({ title: 'The data has been erased' });
      this.setState({ email: '', user: null });
    } catch (response) {
      Modal.error({ content: errorMessage(response) });
    } finally {
      this.setState({ erasing: false });
    }
  }

  renderUser() {
    const { user, erasing } = this.state;

    return (
      <div className="m-24" style={{ marginLeft: 0 }}>
        <p style={{ marginBottom: 4 }}><b>{user.name}</b></p>
        <p style={{ marginBottom: 4 }}>{user.email}</p>
        <p style={{ marginBottom: 4 }}>{ROLE_LABELS[user.type] || user.type}</p>
        <p style={{ marginBottom: 16 }}>{user.church ? user.church.name : 'No church'}</p>

        <Button type="danger" loading={erasing} onClick={this.onErase}>
          Erase this profile's data
        </Button>
      </div>
    );
  }

  render() {
    return (
      <div style={{ marginTop: 40 }}>
        <h2 style={{ marginBottom: 10 }}>Data deletion requests</h2>
        <p>Look a profile up by email address to erase its personal data on request.</p>

        <Row gutter={16} style={{ maxWidth: 560 }}>
          <Col span={16}>
            <Input
              type="email"
              placeholder="Email address"
              value={this.state.email}
              onChange={this.onEmailChange}
              onPressEnter={this.onSearch}
            />
          </Col>
          <Col span={8}>
            <Button onClick={this.onSearch} loading={this.state.searching}>Find profile</Button>
          </Col>
        </Row>

        {this.state.user && this.renderUser()}
      </div>
    );
  }
}

export default compose(
  withApollo,
  graphql(deleteUserData)
)(DataDeletion);



// WEBPACK FOOTER //
// ./src/components/pages/settings/dataDeletion/dataDeletion.js